module.exports = __webpack_public_path__ + "img/send-green-small.34215a5f.svg";